// vatTerms.ts -- the one place a VAT label comes from in EQ Practice's browser
// (2026-10-01, suite contract equilibrium-suite/docs/contracts/vat-terminology.md).
// Reads the vendored suite JSON in ./vendor -- byte-identical to the server copy
// (server/tests/vat-terms.test.ts). LABELS ONLY.

import T from './vendor/vat-terminology.json'

const TERMS = T.terms as Record<string, { label: string; help?: string }>

export function vatTerm(key: string): string {
  const t = TERMS[key]
  if (!t) {
    console.error(`vatTerms: unknown term ${key}`)
    return key
  }
  return t.label
}
